import { ReactElement, useContext } from "react"

import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { AmendAcuDeviceContext } from "../providers/baseProviders/amendAcuDeviceProvider"

const NON_SYS_ADMIN_ACU_STEPS_AMEND = [
    "Core Air Conditioning Unit Details",
    "Upload Supporting Files",
    "Review and Submit",
]

/** AppStepper for amending an Air Conditioning Unit device */
const AmendAcuDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendAcuDeviceContext)

    return (
        <AppStepper
            stepLabels={NON_SYS_ADMIN_ACU_STEPS_AMEND}
            currentStepIndex={currentIndex}
        />
    )
}

export default AmendAcuDeviceProgressStepper
